const Project1 = () => {
    return (
      <div>
        <h1>Project 5: RestroManager</h1>
        <p>This project was developed on Swing API using Java Netbeans with MySQL as DBMS. The purpose of this project was to create a standalone restaurant management app.</p>
      </div>
    );
  };
  
  export default Project1;
  